/* unplugin-vue-components disabled */import script from "./FileIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./FileIcon.vue?vue&type=script&setup=true&lang=js"

import "./FileIcon.vue?vue&type=style&index=0&id=4b510d5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b510d5e"]])

export default __exports__